import { AuthPro } from '@common/Auth'
import { isUltimate } from '@merchant-backend/util'
import {
  getMerchantInfo,
  getPropertyId,
  isSanDaProperty,
  isStoreAccount
} from '@util'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import IframeShopArea from './IframeShopArea'
import {
  AskAnswer,
  Background,
  BottomBar,
  Certification,
  ConsultGift,
  Coupon,
  EasyChat,
  Evaluate,
  Example,
  Gift,
  HotRingComponent,
  JiaMengGoods,
  Meal,
  MerchantActivity,
  MerchantHonor,
  MerchantPromise,
  MerchantUpdates,
  MerchantVideo,
  NewMerchantUpdates,
  Notice,
  RecommendWindow
} from './ShopArea'
import style from './style.module.less'

/**
 * 装修模块是否显示
 * 预览模式下，默认店铺服务（收费）展示
 */
const AuthWrapper = inject('decorationStore')(
  observer(({ decorationStore, children, condition = isUltimate() }) => {
    const { showAll, mode } = decorationStore
    // 完整版预览或编辑模式所有模块都显示
    if (showAll) {
      return <>{children}</>
    }

    return mode === 'preview' ? (
      <AuthPro.Show condition={condition}>{children}</AuthPro.Show>
    ) : (
      children
    )
  })
)

/**
 * TODO，这里模块需做成配置形式
 */
@inject('decorationStore')
@observer
export default class extends Component {
  render() {
    const { decorationStore, useForHomePage = false } = this.props
    const store = decorationStore
    const { themeConfig, decorationModules } = decorationStore
    const property_id = getPropertyId()
    const isJiaMengStore = isStoreAccount()
    /**
     * 测试城市切换店铺装修顺序为问大家-好评率-商家动态
     */
    const DressPhotoImproveTest = getMerchantInfo().dress_photo_improve_test

    /**
     * 后面店铺装修H5展示部分统一走iframe H5，目前仅婚策、婚纱礼服、婚戒走iframe
     */
    const iframeShopArea = [2, 12, 11, 13,14, '2', '11', '12', '13', '14'].includes(
      property_id
    )

    return (
      <div
        className={style.mobile}
        style={{
          backgroundColor: themeConfig['homeBg'],
          color: themeConfig['defaultText']
        }}
      >
        {iframeShopArea ? (
          <IframeShopArea />
        ) : isSanDaProperty() ? (
          decorationModules.map((Component, index) => {
            if (Component && Component.displayName === 'RecommendWindow') {
              return (
                <AuthWrapper>
                  <Component
                    key={index}
                    store={store}
                    decorationStore={store}
                  />
                </AuthWrapper>
              )
            }
            return (
              <Component key={index} store={store} decorationStore={store} />
            )
          })
        ) : (
          <>
            {/* 商家故事 */}
            <Background store={store} />
            {/* 顶部配置 */}
            <MerchantVideo store={store} />
            {/* 商家承诺配置 */}
            <AuthWrapper>
              <MerchantPromise store={store} />
            </AuthWrapper>
            {/* 品牌认证 */}
            {property_id == 12 && <Certification store={store} />}
            {/* 商家荣誉 */}
            <MerchantHonor store={store} />
            {/* 优惠券 */}
            {!useForHomePage && <Coupon store={store} />}
            {/* 公告 */}
            <Notice store={store} />
            {/* 咨询礼 */}
            {!useForHomePage && <ConsultGift store={store} />}
            {/* 到店礼 */}
            {!useForHomePage && <Gift store={store} />}
            <AuthWrapper>
              {/* 商家活动 */}
              <MerchantActivity store={store} />
              {/* 推荐橱窗 */}
              <RecommendWindow store={store} />
            </AuthWrapper>
            {/* 婚戒首饰、非加盟店系列展示 */}
            {property_id == 14 &&
              !isJiaMengStore && <HotRingComponent store={store} />}
            {isJiaMengStore ? (
              <>
                <JiaMengGoods store={store} />
                <Example store={store} />
              </>
            ) : (
              <>
                <Example store={store} />
                <Meal store={store} />
              </>
            )}
            {/* 商家动态 */}
            {!DressPhotoImproveTest && <MerchantUpdates />}
            {/* 问大家 */}
            {!useForHomePage && <AskAnswer store={store} />}
            {/* 好评率 */}
            {!useForHomePage && <Evaluate store={store} />}
            {!!DressPhotoImproveTest && <NewMerchantUpdates />}
            <AuthWrapper condition={isUltimate()}>
              {/* 天眼系统 */}
              <EasyChat store={store} />
            </AuthWrapper>
            <BottomBar store={store} />
          </>
        )}
      </div>
    )
  }
}
